import { _ } from '@ngx-translate/core';
import { IReportCheckboxOption } from '@app/shared/interfaces/report-checkbox-option';
import { CorrelationReportParametersControlKey } from '@app/main/leak-detection/enums/correlation-report-parameters-control-key.enum';

export const CORRELATION_REPORT_PARAMETERS_CHECKBOX_OPTIONS: IReportCheckboxOption<CorrelationReportParametersControlKey>[] =
  [
    {
      controlKey: CorrelationReportParametersControlKey.Map,
      labelKey: _(`@@ld-create-report-dialog__checkbox-map`),
    },
    {
      controlKey: CorrelationReportParametersControlKey.StreetView,
      labelKey: _(`@@ld-create-report-dialog__checkbox-street-view`),
    },
    {
      controlKey: CorrelationReportParametersControlKey.CorrelationGraph,
      labelKey: _(`@@ld-create-correlation-report-dialog__checkbox-correlation-graph`),
    },
    {
      controlKey: CorrelationReportParametersControlKey.CorrelationSpectrum,
      labelKey: _(`@@ld-create-correlation-report-dialog__checkbox-correlation-spectrum`),
    },
    {
      controlKey: CorrelationReportParametersControlKey.SpectrumOfBothLoggers,
      labelKey: _(`@@ld-create-correlation-report-dialog__checkbox-spectrum-both-loggers`),
    },
    {
      controlKey: CorrelationReportParametersControlKey.NoiseLevelHistory,
      labelKey: _(`@@ld-create-report-dialog__checkbox-noise-level-history`),
    },
  ];
